export default __webpack_public_path__ + "static/media/003-cupid arrow.1d4952c8.svg";